import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {QueryClient, QueryClientProvider} from "react-query";
import ModalProvider from "./utils/modal/ModalProvider";
import ModalContainer from "./utils/modal/ModalContainer";
import AuthProvider from "./utils/contextapi/AuthProvider";
import TableProvider from "./utils/contextapi/TableProvider";


const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
        <AuthProvider>
            <ModalProvider>
                <TableProvider>
                    <ModalContainer />
                    <App />
                </TableProvider>
            </ModalProvider>
        </AuthProvider>
    </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
